module.exports = __webpack_public_path__ + "img/avatar_random_5.18a8b1dc.png";